// Define the possible component actions for the reducer to call.
export const ACTIONS = {
  SET_SELECTED_AUDIT: "setSelectedAudit",
  TOGGLE_FETCHING_QUESTION_DATA: "setFetchingQuestionData",
  SET_QUESTION_DATA: "setQuestionData",
  SET_STATUS: "setStatus",
  SET_COMMENTS: "setComments",
  TOGGLE_LOADING: "toggleLoading",
  TOGGLE_PASS_FAIL: "togglePassFail",
  RESET_FORM: "resetForm",
};

// Define the state's initial values.
export const initialState = {
  selectedAudit: { value: "", label: "Select Pending Audit" },
  fetchingQuestionData: false,
  loading: false,
  questionData: null,
  status: "",
  comments: "",
  passFail: true,
  fetchAudits: true,
};

// Define the component's reducer with an action switch and state handling.
export const reducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.SET_SELECTED_AUDIT:
      return {
        ...state,
        selectedAudit: action.value,
        comments: "",
        passFail: true,
      };
    case ACTIONS.TOGGLE_FETCHING_QUESTION_DATA:
      return {
        ...state,
        fetchingQuestionData: state.fetchingQuestionData ? false : true,
      };
    case ACTIONS.SET_QUESTION_DATA:
      return {
        ...state,
        questionData: action.value,
        fetchingQuestionData: false,
        fetchAudits: false,
      };
    case ACTIONS.SET_STATUS:
      return {
        ...state,
        status: action.value,
        fetchingQuestionData: false,
        fetchAudits: false,
        loading: false,
      };
    case ACTIONS.SET_COMMENTS:
      return {
        ...state,
        comments: action.value,
      };
    case ACTIONS.TOGGLE_LOADING:
      return {
        ...state,
        loading: state.loading ? false : true,
      };
    case ACTIONS.TOGGLE_PASS_FAIL:
      return {
        ...state,
        passFail: state.passFail ? false : true,
      };
    case ACTIONS.RESET_FORM:
      return {
        ...state,
        status: "",
        comments: "",
        fetchAudits: true,
        passFail: true,
        selectedAudit: initialState.selectedAudit,
        questionData: initialState.questionData,
      };
    default:
      return state;
  }
};
